import React from 'react';
import { IconButton } from '@material-ui/core';
import { ArrowBackIos, ArrowForwardIos } from '@material-ui/icons';

const BottomNav = ({
    nav,
    currentSlide = nav?.currentSlide ?? 0,
    totalSlides = nav?.currentSegmentSlides?.length ?? 0,
    showPrev = nav ? (nav.currentSlide > 0 || nav.showPrevSegmentButton) : false,
    showNext = nav ? ((nav.currentSegmentSlides?.length > 1 && nav.currentSlide < nav.currentSegmentSlides.length - 1) || nav.showNextSegmentButton) : false,
    onPrevSlide = nav?.handlePrevSlide,
    onNextSlide = nav?.handleNextSlide,
}) => {
    return (
        <>
            {/* Left arrow button */}
            {showPrev && (
                <IconButton
                    onClick={onPrevSlide}
                    disableFocusRipple
                    disableRipple
                    sx={{
                        "&:focus": { outline: "none" },
                        "&:focus-visible": { outline: "none" },
                    }}
                    style={{
                        padding: 0,
                        outline: 'none',
                        position: 'absolute',
                        top: '50%',
                        left: '10px',
                        transform: 'translateY(-50%)',
                        color: 'white',
                        backgroundColor: '#FF6900',
                        borderRadius: '50%',
                        width: '36px',
                        height: '36px',
                        minWidth: '36px',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        zIndex: 10,
                        boxShadow: '0 2px 8px rgba(0, 0, 0, 0.2)',
                    }}
                >
                    <ArrowBackIos style={{ fontSize: '18px', marginLeft: '6px' }} />
                </IconButton>
            )}

            {/* Right arrow button */}
            {showNext && (
                <IconButton
                    onClick={onNextSlide}
                    disableFocusRipple
                    disableRipple
                    sx={{
                        "&:focus": { outline: "none" },
                        "&:focus-visible": { outline: "none" },
                    }}
                    style={{
                        padding: 0,
                        outline: 'none',
                        position: 'absolute',
                        top: '50%',
                        right: '10px',
                        transform: 'translateY(-50%)',
                        color: 'white',
                        backgroundColor: '#FF6900',
                        borderRadius: '50%',
                        width: '36px',
                        height: '36px',
                        minWidth: '36px',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        zIndex: 10,
                        boxShadow: '0 2px 8px rgba(0, 0, 0, 0.2)',
                    }}
                >
                    <ArrowForwardIos style={{ fontSize: '18px' }} />
                </IconButton>
            )}
        </>
    );
};

export const PreviewBottomNav = BottomNav;
export { BottomNav };
export default BottomNav;
